import Heading from "components/common/Heading";
import { getFormattedNumber } from "shared/utility/NumberUtility";

interface Props {
  title: string;
  planDetail: {
    actions: number;
    price: string;
    starts: string;
  };
  description: {
    title?: string;
    titleComponent?: React.ReactElement;
    detail?: string;
    detailComponent?: React.ReactElement;
  };
}

export default function SubscriptionPlanInformation(props: Props) {
  const { title, planDetail, description } = props;
  return (
    <>
      <div className="mb-6">
        <Heading text={title} className="leading-29px" />
      </div>
      <div className="mb-6">
        <div className="text-sm text-promGray2 leading-17px mb-2">NEW PLAN</div>
        <div className="border border-silver rounded-lg p-18px">
          <p className="leading-17px mb-2 font-medium">
            {getFormattedNumber(planDetail.actions)} actions per day
          </p>
          <Heading text={planDetail.price} className="leading-29px mb-6px" />
          <p>
            starts <span className="text-primaryRed">{planDetail.starts}</span>
          </p>
        </div>
      </div>
      <div className="text-sm">
        {description.titleComponent ?? (
          <p className="font-bold">{description.title}</p>
        )}
        {description.detailComponent ?? <p>{description.detail}</p>}
      </div>
    </>
  );
}
